import React from 'react';
import PropTypes from 'prop-types';

import FormManager from '../../../../gd-form/common/form-manager'

import CustomFieldAddFormProto from "../../add-form-proto";
import CustomFieldLeftPanel from "../../common/panel/form-left-panel";
import CustomFieldRightPanel from "core/fields/custom/common/panel/form-right-panel";
import CustomFieldPreview from "../../common/form-preview";
import CustomFieldDecimalPlaces from "../../common/form-decimal-places";
import FormToggle from "../../../../gd-form/form-element/toggle-new/toggle"
import FormRow from "../../../../gd-form/form/form-ui5/form-row"
import FormError from "../../../../gd-form/common/form-error/form-error"

export default class NumberCustomFieldForm extends CustomFieldAddFormProto {

    static propTypes = {
        customField: PropTypes.object,

        onSubmit: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.type = gd.const.customFields.type.NUMBER;

        this.initFormData.decimalPlaces = null
        this.initFormData.positiveOnly = false
        this.initFormData.integersOnly = false

        if (this.props.customField) {
            this.initFormData.decimalPlaces = _.get(this.props.customField.params,'decimalPlaces', null)
            this.initFormData.positiveOnly  = _.get(this.props.customField.params,'positiveOnly', false)
            this.initFormData.integersOnly  = _.get(this.props.customField.params,'integersOnly', false)
        }

        this.state = {
            noDecimalPlaces: this.initFormData.integersOnly
        }

        this.formStructure.fields.decimalPlaces = {
            type: 'select',
            isRequired: false,
            label: 'Decimal places',
            onUserChange: () =>  this.setState({reRender: 1})
        };

        this.formStructure.fields.positiveOnly = {
            type: 'select',
            isRequired: true,
            label: 'Positive only'
        }

        this.formStructure.fields.integersOnly = {
            type: 'select',
            isRequired: true,
            label: 'Integers only',
            onUserChange: () => {
                // hide decimal places and set no 0 if integersOnly is true
                this.form.setValue('decimalPlaces', 0)
                this.setState({noDecimalPlaces: this.form.getValue('integersOnly')})
            }
        }

        this.form = new FormManager(this.formStructure, this.initFormData);
    }

    onSubmit(result) {
        result.name = result.name.trim();
        result.type = gd.const.customFields.type.NUMBER;

        result.params = {
            decimalPlaces   : result.decimalPlaces,
            scope           : result.scope,
            positiveOnly    : result.positiveOnly,
            integersOnly    : result.integersOnly
        }

        this.props.onSubmit(result);
    }

    render() {
        return (
            <React.Fragment>
                <CustomFieldLeftPanel parent={this}>
                    <CustomFieldPreview>
                        <div className="txt m-l-15">{gd.utils.Format.number(1234.56,this.form.getValue('decimalPlaces'),false)}</div>
                    </CustomFieldPreview>
                </CustomFieldLeftPanel>

                <CustomFieldRightPanel parent={this}>
                    <FormRow label="Positive only">
                        <FormToggle size="20" form={this.form} name="positiveOnly" />
                        <FormError form={this.form} name="positiveOnly"/>
                    </FormRow>

                    <FormRow label="Integers only">
                        <FormToggle size="20" form={this.form} name="integersOnly" />
                        <FormError form={this.form} name="integersOnly"/>
                    </FormRow>

                    {!this.state.noDecimalPlaces &&
                        <CustomFieldDecimalPlaces form={this.form}/>}
                </CustomFieldRightPanel>
            </React.Fragment>
        )
    }
}